import type { HardwareGraph } from './types';

export const counterSource = `module counter (
    input  logic       clk,
    input  logic       rst_n,
    input  logic       en,
    output logic [7:0] count
);

always_ff @(posedge clk) begin
    if (!rst_n)
        count <= 8'd0;
    else if (en)
        count <= count + 1'b1;
end

endmodule`;

export const counterGraph: HardwareGraph = {
  schemaVersion: '1.0', module: 'counter', metadata: { parser: 'preview', topModule: 'counter' },
  ports: [
    { id: 'port_clk', type: 'input', label: 'clk', width: 1, source: { file: 'counter.sv', startLine: 2, endLine: 2 }, properties: { direction: 'input' } },
    { id: 'port_rst_n', type: 'input', label: 'rst_n', width: 1, source: { file: 'counter.sv', startLine: 3, endLine: 3 }, properties: { direction: 'input' } },
    { id: 'port_en', type: 'input', label: 'en', width: 1, source: { file: 'counter.sv', startLine: 4, endLine: 4 }, properties: { direction: 'input' } },
    { id: 'port_count', type: 'output', label: 'count', width: 8, source: { file: 'counter.sv', startLine: 5, endLine: 5 }, properties: { direction: 'output' } },
  ],
  nodes: [
    { id: 'const_1', type: 'constant', label: "1'b1", width: 1, source: { file: 'counter.sv', startLine: 12, endLine: 12 }, properties: { value: 1 } },
    { id: 'add_count', type: 'arithmetic', label: 'ADD', width: 8, source: { file: 'counter.sv', startLine: 12, endLine: 12 }, properties: { operation: 'add', expression: "count + 1'b1" } },
    { id: 'reg_count', type: 'register', label: 'count', width: 8, source: { file: 'counter.sv', startLine: 8, endLine: 13 }, properties: { clock: 'clk', clockEdge: 'posedge', reset: 'rst_n', resetType: 'synchronous', resetPolarity: 'active_low', enable: 'en', expression: "count + 1'b1" } },
  ],
  edges: [
    { id: 'e_clk', source: 'port_clk', target: 'reg_count', signal: 'clk', width: 1, kind: 'clock' },
    { id: 'e_rst', source: 'port_rst_n', target: 'reg_count', signal: 'rst_n', width: 1, kind: 'reset' },
    { id: 'e_en', source: 'port_en', target: 'reg_count', signal: 'en', width: 1, kind: 'control' },
    { id: 'e_feedback', source: 'reg_count', target: 'add_count', signal: 'count', width: 8, kind: 'data' },
    { id: 'e_const', source: 'const_1', target: 'add_count', signal: "1'b1", width: 1, kind: 'data' },
    { id: 'e_next', source: 'add_count', target: 'reg_count', signal: 'count_next', width: 8, kind: 'data' },
    { id: 'e_out', source: 'reg_count', target: 'port_count', signal: 'count', width: 8, kind: 'data' },
  ],
};
